// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PoleServicesMapWidget_card__GtOkR {
  background: #ffffff;
  border: 1px solid #dce3e8;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);
  padding: 12px;
}

.PoleServicesMapWidget_header__RKb7o {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.PoleServicesMapWidget_tabs__PkqxA {
  display: flex;
  align-items: center;
  gap: 18px;
}

.PoleServicesMapWidget_tab__ZejfC,
.PoleServicesMapWidget_activeTab__0T6jw {
  appearance: none;
  border: 0;
  border-bottom: 3px solid transparent;
  padding: 0 0 5px;
  background: transparent;
  color: #596b7a;
  font: inherit;
  font-size: 0.88rem;
  cursor: pointer;
}

.PoleServicesMapWidget_activeTab__0T6jw {
  border-bottom-color: #155aa8;
  color: #155aa8;
  font-weight: 700;
}

.PoleServicesMapWidget_tab__ZejfC:hover,
.PoleServicesMapWidget_tab__ZejfC:focus-visible,
.PoleServicesMapWidget_activeTab__0T6jw:focus-visible {
  color: #155aa8;
  outline: none;
}

.PoleServicesMapWidget_poleName__Uic6W {
  color: #243746;
  font-size: 0.88rem;
  font-weight: 600;
}

.PoleServicesMapWidget_mapShell__E8RT0 {
  position: relative;
  min-height: 560px;
  overflow: hidden;
  border-radius: 9px;
  border: 1px solid #d2dce2;
  background: #eef2f4;
}

.PoleServicesMapWidget_map__yOS2S {
  width: 100%;
  height: 560px;
  background: #eef2f4;
}

.PoleServicesMapWidget_state__Fn2Xz,
.PoleServicesMapWidget_error__HkuaU {
  position: absolute;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  background: rgba(238, 242, 244, 0.94);
  color: #526b7f;
}

.PoleServicesMapWidget_error__HkuaU {
  color: #b42318;
}

.PoleServicesMapWidget_mapLabel__5vzCE {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  transform: translate(-50%, -50%);
  background: transparent;
  border: 0;
}

.PoleServicesMapWidget_mapLabel__5vzCE span {
  display: block;
  max-width: 120px;
  padding: 4px 7px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f3443;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
  box-shadow: 0 1px 4px rgba(30, 55, 75, 0.15);
}

.PoleServicesMapWidget_statsOverlay__Lvapz {
  position: absolute;
  z-index: 900;
  transform: translate(-50%, -50%);
  pointer-events: none;
  will-change: left, top;
}

@media (max-width: 1100px) {
  .PoleServicesMapWidget_map__yOS2S,
  .PoleServicesMapWidget_mapShell__E8RT0 {
    height: 460px;
    min-height: 460px;
  }
}

@media (max-width: 760px) {
  .PoleServicesMapWidget_header__RKb7o {
    align-items: flex-start;
    flex-direction: column;
  }

  .PoleServicesMapWidget_map__yOS2S,
  .PoleServicesMapWidget_mapShell__E8RT0 {
    height: 360px;
    min-height: 360px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/PoleServicesMapWidget.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".card {\n  background: #ffffff;\n  border: 1px solid #dce3e8;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);\n  padding: 12px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 10px;\n}\n\n.tabs {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.tab,\n.activeTab {\n  appearance: none;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  padding: 0 0 5px;\n  background: transparent;\n  color: #596b7a;\n  font: inherit;\n  font-size: 0.88rem;\n  cursor: pointer;\n}\n\n.activeTab {\n  border-bottom-color: #155aa8;\n  color: #155aa8;\n  font-weight: 700;\n}\n\n.tab:hover,\n.tab:focus-visible,\n.activeTab:focus-visible {\n  color: #155aa8;\n  outline: none;\n}\n\n.poleName {\n  color: #243746;\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.mapShell {\n  position: relative;\n  min-height: 560px;\n  overflow: hidden;\n  border-radius: 9px;\n  border: 1px solid #d2dce2;\n  background: #eef2f4;\n}\n\n.map {\n  width: 100%;\n  height: 560px;\n  background: #eef2f4;\n}\n\n.state,\n.error {\n  position: absolute;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: center;\n  background: rgba(238, 242, 244, 0.94);\n  color: #526b7f;\n}\n\n.error {\n  color: #b42318;\n}\n\n.mapLabel {\n  width: auto !important;\n  height: auto !important;\n  margin: 0 !important;\n  transform: translate(-50%, -50%);\n  background: transparent;\n  border: 0;\n}\n\n.mapLabel span {\n  display: block;\n  max-width: 120px;\n  padding: 4px 7px;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #1f3443;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.15;\n  text-align: center;\n  white-space: normal;\n  box-shadow: 0 1px 4px rgba(30, 55, 75, 0.15);\n}\n\n.statsOverlay {\n  position: absolute;\n  z-index: 900;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  will-change: left, top;\n}\n\n@media (max-width: 1100px) {\n  .map,\n  .mapShell {\n    height: 460px;\n    min-height: 460px;\n  }\n}\n\n@media (max-width: 760px) {\n  .header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .map,\n  .mapShell {\n    height: 360px;\n    min-height: 360px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `PoleServicesMapWidget_card__GtOkR`,
	"header": `PoleServicesMapWidget_header__RKb7o`,
	"tabs": `PoleServicesMapWidget_tabs__PkqxA`,
	"tab": `PoleServicesMapWidget_tab__ZejfC`,
	"activeTab": `PoleServicesMapWidget_activeTab__0T6jw`,
	"poleName": `PoleServicesMapWidget_poleName__Uic6W`,
	"mapShell": `PoleServicesMapWidget_mapShell__E8RT0`,
	"map": `PoleServicesMapWidget_map__yOS2S`,
	"state": `PoleServicesMapWidget_state__Fn2Xz`,
	"error": `PoleServicesMapWidget_error__HkuaU`,
	"mapLabel": `PoleServicesMapWidget_mapLabel__5vzCE`,
	"statsOverlay": `PoleServicesMapWidget_statsOverlay__Lvapz`
};
export default ___CSS_LOADER_EXPORT___;
